import { CourseCountdown } from '@/components/CourseCountdown';
import { LabradorComponent } from '@/types/component';

export const LabradorCourseCountdown: LabradorComponent = ({ type, meta }) => {
  return <CourseCountdown />;
};
